import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../utils/seo';

export default function ServicesPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mykinesiologue.ma';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${siteUrl}/a-qui-sadresse#webpage`,
    "url": `${siteUrl}/a-qui-sadresse`,
    "name": "À qui s'adresse la kinésiologie - MyKinesiologue Marrakech",
    "description": "La kinésiologie s'adresse aux personnes qui souhaitent comprendre ce que leur corps exprime, traverser une période de transition, accompagner des tensions ou retrouver plus de disponibilité intérieure.",
    "isPartOf": {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F3EE]">
      <SEO
        title="À qui s'adresse la kinésiologie - MyKinesiologue Marrakech"
        description="La kinésiologie s'adresse aux personnes qui souhaitent comprendre ce que leur corps exprime, traverser une période de transition, accompagner des tensions ou retrouver plus de disponibilité intérieure."
        keywords="kinésiologie pour qui, stress persistant, tensions corporelles, transition de vie, gestion stress Marrakech"
        canonical={`${siteUrl}/a-qui-sadresse`}
        schema={schema}
      />

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-8 md:h-12" />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#1F1F1F] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ fontSize: '24px' }}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Accueil</Link>
            <Link to="/approche" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Approche</Link>
            <Link to="/a-qui-sadresse" className="text-[#1F4D45] font-semibold transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>À qui s'adresse</Link>
            <Link to="/presence" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Présence</Link>
            <Link to="/contenus-multimedia" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Contenus multimédia</Link>
            <Link to="/prendre-rendez-vous" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Prendre rendez-vous</Link>
            <Link to="/faq" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>FAQ</Link>
            <Link to="/prendre-rendez-vous#contact" className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-11 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/90 hover:translate-y-[-1px] transition-all duration-300 cursor-pointer ml-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>Me contacter</Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#C9C1B8]">
            <div className="px-4 py-6 flex flex-col gap-4">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Accueil</Link>
              <Link to="/approche" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Approche</Link>
              <Link to="/a-qui-sadresse" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F4D45] font-medium transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>À qui s'adresse</Link>
              <Link to="/presence" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Présence</Link>
              <Link to="/contenus-multimedia" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Contenus multimédia</Link>
              <Link to="/prendre-rendez-vous" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Prendre rendez-vous</Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>FAQ</Link>
              <Link to="/prendre-rendez-vous#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap cursor-pointer mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Me contacter</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 md:pt-48 pb-16 md:pb-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="text-center mb-8 md:mb-12">
            <div className="inline-block border border-[#C9C1B8] rounded-full px-4 py-2 mb-6 md:mb-8">
              <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px' }}>Introduction</span>
            </div>
            <h1 className="text-[#1F1F1F] mb-6 md:mb-8 max-w-4xl mx-auto" style={{ fontFamily: 'Fraunces, serif', fontSize: '50px', lineHeight: '1.1', fontWeight: '600' }}>
              La kinésiologie s'adresse aux personnes qui souhaitent comprendre ce qui se joue dans leur corps
            </h1>
          </div>
          <div className="max-w-3xl mx-auto space-y-6">
            <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              Selon les situations, une séance peut déjà apporter un changement sensible, une amélioration, ou une lecture plus juste de ce qui était resté flou.
            </p>
            <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              Il ne s'agit pas de promettre un résultat, mais de créer les conditions pour que le corps puisse répondre autrement lorsque cela est possible.
            </p>
          </div>
        </div>
      </section>

      {/* Situation 1: Corps en alerte */}
      <section className="py-16 md:py-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2">
              <img 
                src="https://public.readdy.ai/ai/img_res/f1619f40056f9c19e3125d677d719f7a.jpg" 
                alt="Corps en état d'alerte" 
                className="w-full h-[300px] md:h-[500px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
            <div className="w-full md:w-1/2">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-alert-line text-[#1F1F1F]" style={{ fontSize: '48px' }}></i>
              </div>
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Quand le corps reste en alerte
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Certaines personnes vivent dans un état de vigilance prolongée. Le corps s'adapte, compense, tient.
              </p>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Cette adaptation peut se manifester par :
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>un stress persistant</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>une anxiété diffuse</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>une fatigue qui ne se résorbe pas</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>une difficulté à relâcher, même au repos</span>
                </li>
              </ul>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La kinésiologie permet d'identifier là où cette adaptation reste active et de favoriser une régulation plus juste.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Situation 2: Surcharge corporelle */}
      <section className="py-16 md:py-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2 md:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=abstract%20composition%20of%20folded%20and%20draped%20natural%20linen%20fabric%20creating%20organic%20sculptural%20forms%2C%20multiple%20layers%20with%20soft%20shadows%2C%20warm%20ivory%20and%20sand%20tones%2C%20premium%20textile%20art%20photography%2C%20no%20person%2C%20minimalist%20aesthetic%2C%20high-end%20material%20quality%2C%20calm%20serene%20atmosphere%2C%20architectural%20detail%20style&width=700&height=600&seq=draped-linen-layers-v3&orientation=landscape" 
                alt="Surcharge corporelle" 
                className="w-full h-[300px] md:h-[500px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
            <div className="w-full md:w-1/2 md:order-1">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-body-scan-line text-[#1F1F1F]" style={{ fontSize: '48px' }}></i>
              </div>
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Quand le corps exprime une surcharge
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Certaines tensions ou douleurs apparaissent sans cause mécanique évidente. Elles peuvent concerner :
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>la mâchoire (bruxisme)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>les cervicales</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>les épaules</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#1F4D45] mt-1">–</span>
                  <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>certaines douleurs chroniques</span>
                </li>
              </ul>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Ces signaux peuvent être liés à des charges de stress encore présentes.
              </p>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La kinésiologie aide à mieux lire ces manifestations et à permettre au corps de retrouver d'autres modes de réponse.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Situation 3: Transition */}
      <section className="py-16 md:py-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2">
              <img 
                src="https://readdy.ai/api/search-image?query=minimalist%20architectural%20photograph%20of%20doorway%20or%20passage%20between%20two%20spaces%2C%20transition%20from%20light%20to%20shadow%2C%20clean%20geometric%20lines%2C%20warm%20beige%20and%20ivory%20walls%2C%20natural%20daylight%2C%20premium%20interior%20photography%2C%20no%20person%2C%20silent%20contemplative%20space%2C%20high%20quality%20architectural%20detail%2C%20subtle%20gradient%2C%20serene%20professional%20environment&width=700&height=600&seq=doorway-passage-light-v3&orientation=landscape" 
                alt="Période de transition" 
                className="w-full h-[300px] md:h-[500px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
            <div className="w-full md:w-1/2">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-arrow-left-right-line text-[#1F1F1F]" style={{ fontSize: '48px' }}></i>
              </div>
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Quand une transition mobilise fortement le corps
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Certaines périodes de vie demandent une adaptation importante. Même lorsque la situation semble maîtrisée, le corps peut manifester une surcharge.
              </p>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La kinésiologie accompagne ces moments en soutenant la capacité du corps à traverser le changement sans rester figé dans une réponse unique.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Situation 4: Responsabilités élevées */}
      <section className="py-16 md:py-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2 md:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=minimalist%20overhead%20view%20of%20clean%20wooden%20desk%20surface%20with%20single%20open%20notebook%20and%20natural%20light%20casting%20soft%20shadow%2C%20warm%20beige%20and%20wood%20tones%2C%20premium%20workspace%20photography%2C%20no%20person%2C%20simple%20elegant%20composition%2C%20high-end%20material%20quality%2C%20calm%20focused%20atmosphere%2C%20architectural%20detail%20style%2C%20serene%20professional%20environment&width=700&height=600&seq=desk-notebook-overhead-v3&orientation=landscape" 
                alt="Responsabilités élevées" 
                className="w-full h-[300px] md:h-[500px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
            <div className="w-full md:w-1/2 md:order-1">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-briefcase-line text-[#1F1F1F]" style={{ fontSize: '48px' }}></i>
              </div>
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Quand il est nécessaire de rester fonctionnel dans la durée
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Certaines personnes portent des responsabilités élevées : décider, avancer, maintenir un cap.
              </p>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Cette exigence peut s'accompagner de tension continue, récupération difficile ou charge mentale persistante.
              </p>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La kinésiologie peut accompagner ces profils en favorisant une régulation plus stable, plus de clarté mentale et une présence plus juste à soi-même.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cadre clair */}
      <section className="py-16 md:py-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-[#1F4D45]" style={{ fontSize: '64px' }}></i>
            </div>
            <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
              Un cadre clair
            </h2>
            <p className="text-[#5E5A55] mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              La kinésiologie ne constitue pas une pratique médicale et ne se substitue ni à un diagnostic ni à un traitement médical.
            </p>
            <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              L'approche repose sur une obligation de moyens, et non de résultats. Chaque séance ouvre des possibilités, sans jamais les imposer.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact" className="py-16 md:py-32 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 text-center">
          <h2 className="text-[#1F1F1F] mb-4 md:mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
            Vous vous reconnaissez dans ces situations ?
          </h2>
          <p className="text-[#5E5A55] mb-8 md:mb-12 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            Prenons le temps d'échanger sur ce qui vous amène
          </p>
          <a href="mailto:contact@mykinesiologue.ma" className="inline-flex items-center gap-3 bg-[#1F4D45] text-[#F7F3EE] px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:translate-y-[-2px] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
            <i className="ri-mail-line"></i>
            Me contacter
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1F4D45] py-12 md:py-16">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-10" />
              </Link>
              <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                Kinésiologie à Marrakech
              </p>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Navigation
              </h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                <Link to="/" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Accueil</Link>
                <Link to="/contenus-multimedia" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Contenus multimédia</Link>
                <Link to="/approche" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Approche</Link>
                <Link to="/prendre-rendez-vous" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Prendre rendez-vous</Link>
                <Link to="/a-qui-sadresse" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>À qui s'adresse</Link>
                <Link to="/faq" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>FAQ</Link>
                <Link to="/presence" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Présence</Link>
              </div>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Contact
              </h3>
              <div className="flex flex-col gap-2">
                <a href="mailto:contact@mykinesiologue.ma" className="text-[#F7F3EE] hover:underline break-all" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>contact@mykinesiologue.ma</a>
                <a href="tel:+212600000000" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>+212 6 00 00 00 00</a>
                <p className="text-[#E9E0D4] mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  Marrakech, Maroc
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-[#F7F3EE]/20 pt-6 text-center">
            <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px' }}>
              © 2025 MyKinesiologue. Tous droits réservés.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
